import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c(VTabs,[_c(VTab,[_vm._v("Users")]),_c(VTabItem,[_c('Users')],1),_c(VTab,[_vm._v("Holidays")]),_c(VTabItem,[_c('Holiday')],1),_c(VTab,[_vm._v("Activity Codes")]),_c(VTabItem,[_c('ActivityCodes')],1),_c(VTab,[_vm._v("Audit")]),_c(VTabItem,[_c('Audit')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }